import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[checkoutEquipmentBlockHost]',
    standalone: true,
})
export class EquipmentBlockDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
